import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_GUESTS,
  GET_GUEST_DETAIL,
  ADD_NEW_GUEST,
  UPDATE_GUEST,
  DELETE_GUEST,
  UPDATE_GUEST_ACCESS,
  GET_EXPORT_GUEST,
  GUEST_COMPLIMENTARY_ACCESS_REQUEST,
  GUEST_COMPLIMENTARY_ACCESS_GRANT,
} from "./actionTypes"
import {
  getGuestsSuccess,
  getGuestsFail,
  getGuestDetailSuccess,
  getGuestDetailFail,
  addGuestFail,
  addGuestSuccess,
  updateGuestSuccess,
  updateGuestFail,
  deleteGuestSuccess,
  deleteGuestFail,
  updateGuestAccess,
  updateGuestAccessSuccess,
  updateGuestAccessFail,
  getExportGuestSuccess,
  getExportGuestFail,
  guestComplimentaryAccessRequest,
  guestComplimentaryAccessGrant,
  guestComplimentaryAccessGrantFail,
  guestComplimentaryAccessRequestFail,
  guestComplimentaryAccessRequestSuccess,
  guestComplimentaryAccessGrantSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getGuests,
  getGuestsDetails,
  addNewGuest,
  updateGuest,
  deleteGuest,
  updateGuestApproveAccess,
  getExportGuest,
  guestRequestComplimentary,
  guestGrantComplimentary,
} from "helpers/backend_helper"

function* fetchGuests({ payload }) {
  try {
    const response = yield call(getGuests, payload)
    yield put(getGuestsSuccess(response))
  } catch (error) {
    yield put(getGuestsFail(error))
  }
}

function* fetchGuestDetail({ GuestId }) {
  try {
    const response = yield call(getGuestsDetails, GuestId)
    yield put(getGuestDetailSuccess(response))
  } catch (error) {
    yield put(getGuestDetailFail(error))
  }
}

function* onUpdateGuest({ payload: Guest }) {
  try {
    const response = yield call(updateGuest, Guest)
    if (response?.success) {
      yield put(updateGuestSuccess(response))
    } else {
      yield put(updateGuestFail(response))
    }
  } catch (error) {
    yield put(updateGuestFail(error))
  }
}

function* onAddNewGuest({ payload: Guest }) {
  try {
    const response = yield call(addNewGuest, Guest)
    if (response?.success) {
      yield put(addGuestSuccess(response))
    } else {
      yield put(addGuestFail(response))
    }
  } catch (error) {
    yield put(addGuestFail(error))
  }
}

function* onDeleteGuest({ payload: Guest }) {
  try {
    const response = yield call(deleteGuest, Guest)
    if (response?.success) {
      yield put(deleteGuestSuccess(Guest))
    } else {
      yield put(deleteGuestFail(response))
    }
  } catch (error) {
    yield put(deleteGuestFail(error))
  }
}

function* onUpdateGuestAccess({ payload: Guest }) {
  try {
    const response = yield call(updateGuestApproveAccess, Guest)
    if (response?.success) {
      yield put(updateGuestAccessSuccess(response))
    } else {
      yield put(updateGuestAccessFail(response))
    }
  } catch (error) {
    yield put(updateGuestAccessFail(error))
  }
}

function* fetchExportGuest({ payload }) {
  try {
    const response = yield call(getExportGuest, payload)
    if (response?.success) {
      yield put(getExportGuestSuccess(response))
    }else {
      yield put(getExportGuestFail(response))
    }
    
  } catch (error) {
    yield put(getExportGuestFail(error))
  }
}

function* guestComplimentaryRequest({payload}){
  try{
    const response = yield call(guestRequestComplimentary, payload);
    yield put(guestComplimentaryAccessRequestSuccess(response));
  }catch(error){
    yield put(guestComplimentaryAccessRequestFail(error));
  }
}

function* guestComplimentaryGrant({payload}){
  try{
    const response = yield call(guestGrantComplimentary, payload);
    yield put(guestComplimentaryAccessGrantSuccess(response));
  }catch(error){
    yield put(guestComplimentaryAccessGrantFail(error));
  }
}

function* GuestSaga() {
  yield takeEvery(GET_GUESTS, fetchGuests)
  yield takeEvery(GET_GUEST_DETAIL, fetchGuestDetail)
  yield takeEvery(ADD_NEW_GUEST, onAddNewGuest)
  yield takeEvery(UPDATE_GUEST, onUpdateGuest)
  yield takeEvery(DELETE_GUEST, onDeleteGuest)
  yield takeEvery(UPDATE_GUEST_ACCESS, onUpdateGuestAccess)
  yield takeEvery(GET_EXPORT_GUEST, fetchExportGuest)
  yield takeEvery(GUEST_COMPLIMENTARY_ACCESS_REQUEST, guestComplimentaryRequest);
  yield takeEvery(GUEST_COMPLIMENTARY_ACCESS_GRANT, guestComplimentaryGrant)
}

export default GuestSaga
